export const SET_DATA_ORDER = "[ORDER_TYPES] SET_DATA_ORDER";
export const CANCELLED_ORDER = "[ORDER_TYPES] CANCELLED_ORDER";
export const ASSIGN_ORDER = "[ORDER_TYPES] ASSIGN_ORDER";
export const ASSIGN_DATE_TO_VISIT = "[ORDER_TYPES] ASSIGN_DATE_TO_VISIT";
